import React, { useState } from 'react'
import { Dropdown, Tabs, Menu } from 'antd'

import { AiOutlineDown } from 'react-icons/ai'
import { BiSelectMultiple } from 'react-icons/bi'

import { normalize, server, stringifyDate, usePet, useToggle } from '../../modules'
import { useSelector } from 'react-redux'

import Modal from "../resusable/modal"
import Receive from '../resusable/receive'

const { TabPane } = Tabs

const OrderModal = ({ toggle, visible, order: ord, onPerform }) => {
    const [chosen, setChosen] = useState([])
    const [select, toggleSelect] = useToggle()

    const [{ loading, error, data: order }] = usePet('order', { id: ord?._id }, { notify: true })

    const { user } = useSelector(state => state.application)

    const togSelect = () => {
        setChosen([])
        toggleSelect()
    }

    const choose = id => {
        let temp = [...chosen]

        if (temp.includes(id)) {
            temp = temp.filter(x => x !== id)
        } else {
            temp.push(id)
        }

        setChosen(temp)
    }

    const onComplete = (_, notif, ops) => {
        notif('Bill has been split', ops('success'))
        onPerform()
        setTimeout(toggle, 300)
    }

    const [{ loading: sLoading }, split] = usePet('splitItemsFromBill', {
        parent: ord?._id,
        ids: chosen
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Splitting items...' } })

    const [{ loading: capLoading }, reprintCaptainOrders] = usePet('reprintCaptainOrders', {
        bill: ord?._id,
        items: chosen,
        targets: localStorage
    }, { 
        notify: true, 
        callback: (_, notif, ops) => notif('Request has been sent', ops('success')), 
        manual: true, 
        load: { msg: 'Sending Request...' } 
    })

    const [, printBill] = usePet('printBillByCashier', { 
        bill: ord?._id,
        target: localStorage.getItem('Bill')
    }, { notify: true, callback: () => null, manual: true, load: { msg: 'Printing bill...' } })    

    return (
        <Modal
            h="h-auto my-5"
            // w="w-5/6 md:w-4/5 xl:w-3/5 2xl:w-2/5 mt-5"
            align="items-start"
            title={`Bill #${ord?.orderNo}`}
            toggle={toggle}
            visible={visible}>
            <Receive
                loading={loading}
                error={error}>
                <Tabs defaultActiveKey="1">
                    <TabPane tab="Items" key="1">
                        <span className="flex justify-end">
                            {
                                !ord?.closed ?
                                    chosen.length > 0 ?
                                        <Dropdown
                                            overlay={
                                                <Menu>
                                                    <Menu.Item onClick={togSelect}>Deselect All</Menu.Item>
                                                    {
                                                        order?.items?.length !== chosen.length ?
                                                            <Menu.Item onClick={split}>Split Selected Items</Menu.Item>
                                                            : null
                                                    }
                                                    {
                                                        user?.username === 'root' ?
                                                        <Menu.Item onClick={reprintCaptainOrders}>Reprint Captain Orders</Menu.Item>
                                                        : null
                                                    }
                                                </Menu>
                                            }>
                                            <button className="btn mb-3 hisani-btn-green text-white">
                                                <span className="hidden xs:block mr-2">Actions ({chosen.length})</span>
                                                <AiOutlineDown />
                                            </button>
                                        </Dropdown>
                                        : order?.items?.length > 1 ?
                                            <button onClick={togSelect} className="btn mb-3 hisani-btn-green text-white">
                                                <BiSelectMultiple style={{ color: "white" }} />
                                                <span className="hidden xs:block ml-2">{!select ? "Select" : "Deselect All"}</span>
                                            </button>
                                            : null
                                    : null
                            }
                        </span>
                        <table className="table-auto w-full">
                            {/* Table header */}
                            <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                <tr>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">No</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Item</div>
                                    </th>
                                    {/* <th className="p-2">
                                        <div className="font-semibold text-left">Station</div>
                                    </th> */}
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Status</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Quantity</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Unit Price</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Total</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left"></div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="text-sm font-medium divide-y divide-gray-100">
                                {
                                    order?.items?.map((item, key) =>
                                        <tr>
                                            <td className="p-2">
                                                <div className="text-center">
                                                    {
                                                        select ?
                                                            <input
                                                                onChange={() => choose(item._id)}
                                                                checked={chosen.includes(item._id)}
                                                                type="checkbox"
                                                                className="form-checkbox cursor-pointer h-5 w-5" />
                                                            : `${key + 1}.`
                                                    }
                                                </div>
                                            </td>
                                            <td className="p-2">
                                                <div className="text-left">{item?.ref?.name ?? item?.name}</div>
                                            </td>
                                            {/* <td className="p-2 text-left">
                                                <div className="text-left">{item.destination.name}</div>
                                            </td> */}
                                            <td className="p-2">
                                                <div className="text-left text-green-500">Completed</div>
                                            </td>
                                            <td className="p-2 text-left">
                                                <div className="text-left">X {item.quantity}</div>
                                            </td>
                                            <td className="p-2 text-left">
                                                <div className="text-left">Ksh. {item.unitPrice}</div>
                                            </td>
                                            <td className="p-2 text-left">
                                                <div className="text-left">Ksh. {item.quantity * item.unitPrice}</div>
                                            </td>
                                            <td className="p-2">
                                                {/* <FilterButton /> */}
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                        <div className="flex flex-col items-end pr-3 py-3">
                            <p className="font-semibold text-lg underline mb-2">Overview</p>
                            <p className="mb-1">Before Tax: Ksh. {normalize(order?.items?.reduce((total, itm) => total + (itm?.unitPrice * itm?.quantity * ((100 - itm?.taxRate) / 100)), 0))}</p>
                            <p className="mb-1">Tax ({order?.items[0]?.taxRate}%): Ksh. {normalize(order?.items?.reduce((total, itm) => total + ((itm?.unitPrice * itm?.quantity) * (itm?.taxRate / 100)), 0))}</p>
                            <p className="mb-1">Discount: Ksh. {normalize(order?.discount ?? 0)}</p>
                            <p className="mb-1">Complementary: Ksh. {normalize(order?.complementary ?? 0)}</p>
                            <p className="mb-1">Total: Ksh. {normalize(order?.items?.reduce((total, itm) => total + (itm?.unitPrice * itm?.quantity), 0) - (order?.discount ?? 0) - (order?.complementary ?? 0))}</p>
                        </div>
                    </TabPane>
                    <TabPane tab="Payments" key="2">
                        {
                            order?.payments?.length > 0 ?
                                <table className="table-auto w-full">
                                    {/* Table header */}
                                    <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                        <tr>
                                            <th className="p-2">
                                                <div className="font-semibold text-center">No</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-left">Method</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-center">Amount</div>
                                            </th>
                                            <th className="p-2">
                                                <div className="font-semibold text-center">Date</div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-sm font-medium divide-y divide-gray-100">
                                        {
                                            order?.payments?.map((payment, key) =>
                                                <tr>
                                                    <td className="p-2">
                                                        <div className="text-center">{key + 1}.</div>
                                                    </td>
                                                    <td className="p-2">
                                                        {payment.method}
                                                        <p className="text-gray-500 text-xs italic">{payment.description}</p>
                                                    </td>
                                                    <td className="p-2 text-center">
                                                        <div className="text-center">Ksh. {Math.abs(payment.amount)}</div>
                                                    </td>
                                                    <td className="p-2 text-center">
                                                        <div className="text-center">{stringifyDate(payment.date)}</div>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                                :
                                <div className="w-full h-16 flex items-center justify-center">
                                    <p className="font-semibold text-base">No payments have been recorded for this bill</p>
                                </div>
                        }
                    </TabPane>
                    <TabPane tab="Details" key="3">
                        <h2>Served By</h2>
                        <p>{order?.servedBy?.name}</p>
                        <hr />
                        {
                            order?.table ?
                            <>
                                <h2 className="mt-2">Table</h2>
                                <p>{order?.table}</p>
                                <hr />
                            </> : null
                        }
                        <h2 className="mt-2">Status</h2>
                        <p className={`${order?.waived || order?.voided ? 'text-red-400' : order?.closed ? 'text-green-500' : order?.shelved ? 'text-blue-500' : 'text-yellow-500'}`}>{ order?.voided ? 'Voided' : order?.waived ? 'Waived' : order?.closed ? 'Closed' : order?.shelved ? 'Shelved' : 'Open'}</p>
                        <hr />
                        {
                            order?.waived ?
                            <>
                                <h2 className="mt-2">Waived By</h2>
                                <p>{order?.waivedBy?.name}</p>
                                <hr />
                            </> : null
                        }
                        {
                            order?.discount ?
                            <>
                                <h2 className="mt-2">Discount</h2>
                                <p>Amount: Ksh. {order?.discount}</p>
                                <p>Authorized By {order?.discountedBy?.name}</p>
                                <hr />
                            </> : null
                        }
                        {
                            order?.complementary ?
                            <>
                                <h2 className="mt-2">Complementary</h2>
                                <p>Amount: Ksh. {order?.complementary}</p>
                                <p>Authorized By {order?.complementaryAuthBy?.name}</p>
                                <hr />
                            </> : null
                        }
                        {
                            order?.shelved && !order?.closed ?
                            <>
                                <h2 className="mt-2">Shelved By</h2>
                                <p>{order?.shelvedBy?.name}</p>
                                <p>{order?.owner}</p>
                                <hr />
                            </> : null
                        }
                        {
                            order?.voided ?
                            <>
                                <h2 className="mt-2">Voided By</h2>
                                <p>{order?.voidedBy?.name}</p>
                                <p style={{ whiteSpace: 'pre-line' }}>{order?.reasonForVoid}</p>
                                <hr />
                            </> : null
                        }
                        {
                            order?.notes ?
                            <>
                                <h2 className="mt-2">Notes</h2>
                                <p style={{ whiteSpace: 'pre-line' }}>{order?.notes}</p>
                            </> : null
                        }
                    </TabPane>
                </Tabs>
            </Receive>
            <div className="flex mt-2 justify-end">
                <button onClick={toggle} className="px-4 rounded-md outline-none focus:ring-4 shadow-lg mr-4">Close</button>
                {/* <a className="text-gray-600" rel="noreferrer" target="_blank" href={`${server}/receipt/${ord?._id}/print`}> */}
                <button onClick={printBill} type="submit" className="text-white hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Print Bill</button>
                {/* </a> */}
            </div>
        </Modal>
    )
}

export default OrderModal